import React, { useEffect, useState } from 'react'
import green from '../../Images/Vector 18.png';
import red from '../../Images/Vector 19.png';
import GoogleBarChart from './GoogleBarChart';
import { ResponsiveContainer, YAxis, BarChart, Tooltip, Legend, Bar, XAxis } from 'recharts'
import { Link } from 'react-router-dom';

const Revenue = ({ data,sales, profit,compareProfit }) => {
    console.log("TESS08",sales);
    
    return (
        <>
            <div className='revenue_main'>
                <div className='revenue_wrapper'>
                    <div className='net_income_head_wrapper' style={{
                        borderBottom: '1px solid #ccc',
                        paddingBottom: '17px'
                    }}>
                        <h5 style={{
                            marginBottom: '0px',
                        }}>Revenue</h5>
                        <div className='income_expenses_wrapper'>
                            <div className='income_div_wrapper'>
                                <div className='income_div565'></div>
                                <p>Sales</p>
                            </div>
                            <div className='expenses_div_wrapper'>
                                <div className='expenses_div565'></div>
                                <p>Expenses</p>
                            </div>
                        </div>
                    </div>

                    <div className='revenue_graph_wrapper'>
                        {/* <h2 className='revenue_head8697'><i className="fa fa-indian-rupee-sign"></i>193.000 <span><img src={green} />+35% </span> <p>from last month</p> </h2> */}
                        <h2 className='revenue_head8697'><i className="fa fa-indian-rupee-sign"></i>{profit?.value} <span style={{ color: compareProfit.increase ? "#7BC498" : "#ff0000" }}><img src={compareProfit.increase ? green : red} />{compareProfit.increase ? "+" : "-"}{compareProfit?.value}% </span> <p>from last month</p> </h2>
                        <div className='revenue_graph'>
                            <ResponsiveContainer width={'100%'}>
                                <BarChart height={145} data={data}>
                                    <XAxis dataKey="month" />

                                    <Tooltip />
                                    <Bar dataKey="Sales" fill="rgb(39, 80, 71)" />
                                    <Bar dataKey="Expenses" fill="rgb(172, 221, 54)" />
                                    
                                </BarChart>
                            </ResponsiveContainer>
                        </div>
                    </div>

                </div>

                <div className='revenue_wrapper revenue_height'>
                    <div className='net_income_head_wrapper'>
                        <h5>Sales</h5>
                        <Link to="/sales"><i class="fas fa-long-arrow-alt-right"></i></Link>
                    </div>

                    <div className='revenue_graph_wrapper'>

                        <div className='revenue_graph'>
                            <GoogleBarChart data={sales} />
                        </div>
                    </div>

                </div>
            </div>

        </>
    )
}

export default Revenue
